export default "__VITE_ASSET__nd_XgsHb__"